<!-- <div class="custombg fixed-top">
  <app-header #header></app-header>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb mb-0 ">
      <li class="breadcrumb-item active" aria-current="page" (click)="goToHome()" style="cursor:pointer">Home &nbsp;
      </li>
      <li class="breadcrumb-item active" style="cursor:pointer " (click)="switchDeckView()">KMS Portal &nbsp; </li>
      <li class="breadcrumb-item active" aria-current="page">Users</li>
    </ol>
  </nav>
</div> -->
<div class="wrapper">
  <div class="container mr-0">
    <div class="row" align="right">
      <div class="col-12 p-2 mt-2 alignment">
        <button type="button" class="btn btn-primary add-btn" (click)="addUser()" aria-haspopup="true"
          aria-expanded="false"><i class="fas fa-plus"></i> Add User</button>
      </div>
    </div>
  </div>
  <div class="modal-container">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-12 col-xl-12 p-2 mt-2 ">

        <div class="card margin-bottom-to-footer">
          <!---Title-->
          <div class="row d-flex p-3 m-0 border-bottom">
            <div class="heading_1  mr-auto ">Users</div>
            <div class="heading_1 input-group ">
              <input class="form-control" style="border-right: none;" #searchterm [(ngModel)]="searchText"
                (keyup.enter)="searchUser()" id="myInput" type="text" placeholder="Search for Users.." (keydown)="onKeyDown($event)"
                [class.searchClose]="searchText==''">
              <button type="submit" class="search-icon  " (click)="clearSearchText()" *ngIf="searchText!=''"><i
                  class="fa fa-times icon"></i></button>
              <div class="input-group-append">
                <button class="btn btn-outline-secondary searchfield-right btn-search" id="text-search" type="button"><i
                    class="fas fa-search search" (click)="searchUser()"></i></button>
              </div>
            </div>


          </div>

          <!---row loop-->
          <div class="row p-3 m-0 border-bottom" *ngFor="let user of users">
            <div class="col p-0">
              <div class="row">
                <div class="col-12 col-md-2 col-lg-2 text-truncate">
                  <div class="pr-2 mt-3">
                    <mat-checkbox color="primary" (change)="addToDeleteList(user,$event)"
                      [disabled]="signedInUserDetails.email === user.userEmail &&
                    (checkRole(userRoles.SuperAdmin) || checkRole(userRoles.Admin))
                    || (user.userRole === userRoles.SuperAdmin && checkRole(userRoles.Admin))
                    || (!checkRole(userRoles.SuperAdmin) && signedInUserDetails.organizationId !== user.organizationId )"></mat-checkbox>
                  </div>
                </div>
                <div class="col-12 col-md-2 col-lg-2 text-truncate">
                  <div class="pr-2">
                    <div><span class="secondaryInfo">User Name </span></div>
                    <div class="text-truncate"><span class="heading_3" matTooltip="{{user.userName}}"
                      placement="bottom">{{user.userName}}</span></div>
                  </div>
                </div>
                <div class="col-12 col-md-2 col-lg-2 text-truncate">
                  <div class="pr-2">
                    <div><span class="secondaryInfo">Email Id</span></div>
                    <div class="text-truncate"><span class="heading_3" matTooltip="{{user.userEmail}}"
                      placement="bottom">{{user.userEmail}}</span></div>
                  </div>
                </div>
                <div class="col-12 col-md-2 col-lg-2 ">
                  <div class="pr-2">
                    <div><span class="secondaryInfo">Role</span></div>
                    <div class="text-truncate"><span class="heading_3"  matTooltip="{{getRole(user.userRole)}}"
                      placement="bottom">{{getRole(user.userRole)}}</span></div>
                  </div>
                </div>
                <div class="col-12 col-md-2 col-lg-2 ">
                  <div class="pr-2">
                    <div><span class="secondaryInfo">Organization</span></div>
                    <div class="text-truncate"><span class="heading_3"  matTooltip="{{user.organizationName}}"
                      placement="bottom">{{user.organizationName}}</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-auto d-flex p-0 border-left">
              <div class="buttons_column align-self-center  p-0">
                <button type="button" [disabled]="signedInUserDetails.email === user.userEmail 
                 || (user.userRole === userRoles.SuperAdmin && checkRole(userRoles.Admin))
                 || (!checkRole(userRoles.SuperAdmin) && signedInUserDetails.organizationId !== user.organizationId )
                 " class="btn btn-custom_primary ml-2 mr-2" (click)="updateUser(user)" id="inv_setup_save"
                  data-toggle="modal" data-target="" data-backdrop="static" data-keyboard="false">Edit
                </button>
                <button type="button" [disabled]="signedInUserDetails.email === user.userEmail &&
                 (checkRole(userRoles.SuperAdmin) || checkRole(userRoles.Admin))
                 || (user.userRole === userRoles.SuperAdmin && checkRole(userRoles.Admin))
                 || (!checkRole(userRoles.SuperAdmin) && signedInUserDetails.organizationId !== user.organizationId )"
                  class="btn btn-custom_primary ml-2 mr-2 " (click)="deleteUser(user.id)" id="inv_setup_save"
                  data-toggle="modal" data-target="" data-backdrop="static" data-keyboard="false">Delete</button>
              </div>
            </div>
          </div>
          <div *ngIf="users && users.length == 0 && !loading" class="text-center">
            No Users Found
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


<!-- <div class="overlay" (click)="dismissSidebar()"></div> -->

<div #actions class="actions">
  <div>
    <i class="far fa-trash-alt whiteFont" (click)="deleteMultipleUsers()"></i>
  </div>
</div>